import React, { useReducer, createContext } from "react";
import { userReducer, userInitialState } from "../reducers";
import constant from "../constants/userConstant";
import { userService } from "../services";
import { toast } from "react-toastify"

export const UserContext = createContext();

export const UserContextProvider = (props) => {

    const [state, dispatch] = useReducer(userReducer, userInitialState);

    const get = (username) => {

        dispatch(request());

        userService.get(username).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("the user couldn't be fetched!");

                dispatch(fail());
            });

        function success(data) { return { type: constant.GET_SUCCESS, payload: data }; }
        function fail() { return { type: constant.GET_FAIL }; }
        function request() { return { type: constant.GET_REQUEST }; }
    };

    const add = (data, onSuccess) => {

        dispatch(request());

        userService.add(data).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }
                
                toast.info("please check your email and confirm your email address!");
                
                // localStorage.setItem(process.env.REACT_APP_LS_USER,
                //     JSON.stringify(response.data.user));

                // localStorage.setItem(process.env.REACT_APP_LS_TOKEN, response.data.token);

                // dispatch(success(response.data.user));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("the user couldn't be added!");

                dispatch(fail());
            });

        function success(data) { return { type: constant.ADD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.ADD_FAIL }; }
        function request() { return { type: constant.ADD_REQUEST }; }
    };

    const update = (data, onSuccess) => {

        dispatch(request());

        userService.update(data).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }
                
                dispatch(success(true));
                
                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("the user couldn't be updated!");

                dispatch(fail());
            });

        function success(data) { return { type: constant.UPDATE_SUCCESS, payload: data }; }
        function fail() { return { type: constant.UPDATE_FAIL }; }
        function request() { return { type: constant.UPDATE_REQUEST }; }
    };

    return (
        <UserContext.Provider value={[state, { get, add, update }]}>
            {props.children}
        </UserContext.Provider>
    );
};

